import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgIf } from '@angular/common';

import { pageTransitions } from '../../../../shared/animations/page-transitions';
import { Guarantee } from '../../../models/guarantee';
import { LocationService } from '../../../../shared/services/location.service';
import { User } from '../../../../shared/models/user';
import { UserService } from '../../../../shared/services/user.service';

import { GuaranteeTypeSelectorComponent } from './guarantee-type-selector.component';
import { ProjectCharacteristicsOrganicComponent } from './project-characteristics-organic.component';
import { ProjectCharacteristicsBuildingComponent } from './project-characteristics-building.component';
import { ProjectCharacteristicsOtherComponent } from './project-characteristics-other.component';
import { ProjectCharacteristicsSolarComponent } from './project-characteristics-solar.component';

@Component({
	selector: 'copo-project-characteristics',
	templateUrl: './project-characteristics.component.html',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		NgIf,
		ProjectCharacteristicsSolarComponent,
		ProjectCharacteristicsOtherComponent,
		ProjectCharacteristicsBuildingComponent,
		ProjectCharacteristicsOrganicComponent,
		GuaranteeTypeSelectorComponent
	]
})

export class ProjectCharacteristicsComponent {
	@Input() guaranteeResponse!: Guarantee;

	guarantee!: Guarantee;

	user: User;
	constructor(

		private readonly route: ActivatedRoute,
		private readonly locationService: LocationService,
		private readonly userService: UserService,
	) {
		const res = <{ guarantee: Guarantee }> this.route.snapshot.data;
		this.guarantee = res['guarantee'];

		this.user = this.userService.user;
		if (!this.guarantee.applicationType) {
			this.locationService.go(-1, '../guarantee-requests/new/guarantee-type-selector');
		}
	}

	goBack() {
		if (this.guarantee.id !== undefined) {
			this.locationService.go(-1);
		} else {
			this.locationService.go(-1, '../guarantee-requests/new/guarantee-type-selector');
		}
	}
}
